import { render } from "./VoidOrderButton.vue?vue&type=template&id=5c293c63"
import script from "./VoidOrderButton.vue?vue&type=script&lang=js"
export * from "./VoidOrderButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__